<!--上传站点照片-->
<template>
    <div>
        <el-upload
            class="upload-demo"
            action=""
            multiple
            :on-change="upload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="files"
            :auto-upload="false"
            list-type="picture-card"
            :limit="limit"
        >
            <i slot="default" class="el-icon-plus">
                <span style="font-size: 1vw">{{ showText }}</span>
            </i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
export default {
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            fileList: [], //图片列表
            files: [],
        };
    },
    props: {
        imgList: Array,
        limit: Number, //最大允许上传个数
        showText: String, //图标显示文本
        site: Boolean,
    },
    watch: {
        fileList: {
            handler(val) {
                this.$emit("upload", this.JsonData(val));
            },
        },
    },
    mounted() {
        // 传递过来的站点图片
        this.fileList = this.imgList;
        let imgObject = [];
        for (let i = 0; i < this.imgList.length; i++) {
            imgObject[i] = {
                url: "",
            };
            if (this.imgList[i].substring(0, 4) == "http") {
                imgObject[i].url = this.imgList[i];
            } else {
                imgObject[i].url = "http://ecar.meisenpay.com" + this.imgList[i];
            }
        }
        this.files = imgObject;
    },
    computed: {
        ...mapState(["imgPath"]),
    },
    methods: {
        /*删除*/
        handleRemove(file, fileList) {
            // file: 删除的图片，fileList：剩下的图片
            // console.log(fileList)
            let paths = [];
            for(let i =0;i<fileList.length;i++) {
                paths.push(fileList[i].url.match(/http:\/\/ecar.meisenpay.com(\S*)/)[1])
            }
            this.fileList = paths;
        },
        /*放大预览*/
        handlePreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        /*上传图片*/
        async upload(file) {
            let fileData = file.raw;
            if (typeof fileData == "undefined") {
                return;
            }
            if (fileData.size > 2 * 1024 * 1024) {
                util.ShowTip("图片大小不能超过2M", 2);
                return;
            }
            let formData = new FormData();
            formData.append("file", fileData);
            await store.dispatch("uploadImg", formData);
            if (!this.site) {
                this.fileList = [];
                this.fileList.push(this.imgPath);
            } else {
                this.fileList.push(this.imgPath);
            }
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
};
</script>
